import React from 'react';
import { FormikProps } from 'formik';
import { useTranslation } from 'react-i18next';
import { MAX_COMMENT_LENGTH } from 'Utils';
import { FormikFieldTextArea } from 'Components/FormikComponents/';
import styles from './styles.css';

type Props = {
    formikProps?: FormikProps<any>;
    error?: any;
};

const Comment = ({ formikProps, error }: Props) => {
    const { t } = useTranslation();

    return (
        <div className={styles.formBlock}>
            <FormikFieldTextArea
                dataTestId='comment'
                name='comment'
                id='list-entry-comment'
                label={t('Comment (Optional)')}
                maxChar={MAX_COMMENT_LENGTH}
                disabled={formikProps?.isSubmitting}
                onChange={formikProps?.handleChange}
                error={
                    !!(formikProps?.errors.comment && formikProps?.touched.comment) ||
                    error?.data?.error?.param === 'comment'
                }
                errorMsg={formikProps?.errors.comment as string}
            />
        </div>
    );
};

export default Comment;
